import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./auth-context";

/**
 * 只保護雲端功能的守衛：登入後才可使用的路由。
 * 未登入時導向 /login?next=<encoded 當前路由>，登入成功後返回。
 */
export function RequireAccount({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      const encoded = encodeURIComponent(`${location.pathname}${location.search}`);
      navigate(`/login?next=${encoded}`, { replace: true });
    }
  }, [user, loading, location, navigate]);

  if (loading || !user) {
    return null;
  }

  return <>{children}</>;
}
